import Vue from 'vue'

Vue.use({
  install(Vue) {
    Vue.prototype.$isMobile = () => {
      return process.client && window.innerWidth < 768
    }
  },
})
